// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const RotateLeft: React.FC<SvgProps> = (props) => (
  <Svg width="12" height="11.587" {...props} viewBox="0 0 12 11.587">
    <path
      data-name="パス 185"
      d="M1.465-11.285h-.22a.619.619 0 0 1-.621-.621v-3.31a.62.62 0 0 1 .383-.574.622.622 0 0 1 .678.134l1.076 1.076a5.792 5.792 0 0 1 8.167.026 5.792 5.792 0 0 1 0 8.193 5.792 5.792 0 0 1-8.193 0 .829.829 0 0 1 0-1.171.829.829 0 0 1 1.171 0 4.138 4.138 0 0 0 5.852 0 4.138 4.138 0 0 0 0-5.852 4.137 4.137 0 0 0-5.826-.026L5-12.346a.622.622 0 0 1 .134.678.62.62 0 0 1-.574.383H1.465z"
      transform="translate(-.625 16.251)"
    />
  </Svg>
);

RotateLeft.displayName = 'RotateLeft';

export default RotateLeft;
